import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { VideoMaxAdDurationTargeting } from '@openx/types/targeting/targetingValuesTypes';
import type { AdDurationOption, MaxAdDurationStatePayload } from '@openx/types/targeting/video';
import { SelectedItems } from '../../../../shared/SelectedItems/SelectedItems';

type Props = {
  params: Partial<MaxAdDurationStatePayload>;
  readonly: boolean;
  getItemLabel: (option: AdDurationOption) => string;
  handleChange: () => void;
  adDurationOptions: Record<string, { name: string }>;
};

export const MaxAdDurationSelectedItems = ({
  params,
  getItemLabel,
  readonly,
  handleChange,
  adDurationOptions,
}: Props) => {
  switch (params.type) {
    case VideoMaxAdDurationTargeting.BETWEEN:
      return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start', gap: 1 }}>
          <Box sx={{ mr: -7 }}>
            <SelectedItems
              isAddIcon={true}
              hideIcon={!params.start}
              selectedItems={params.start ? [params.start] : [null]}
              getItemLabel={getItemLabel}
              readonly={readonly}
              handleChange={handleChange}
              filtersTitle={adDurationOptions[params.type].name}
              enableRemoveOneItem={false}
              dataTest="max-ad-duration-from"
            />
          </Box>
          <Box>
            <Typography
              color="textSecondary"
              sx={{
                lineHeight: 2,
              }}
            >
              <HorizontalRuleIcon sx={{ fontSize: '0.75rem' }} />
            </Typography>
          </Box>
          <Box>
            <SelectedItems
              isAddIcon={true}
              selectedItems={params.end ? [params.end] : []}
              getItemLabel={getItemLabel}
              readonly={readonly}
              hideTitle={true}
              handleChange={handleChange}
              enableRemoveOneItem={false}
              dataTest="max-ad-duration-to"
            />
          </Box>
        </Box>
      );
    case VideoMaxAdDurationTargeting.EXACT:
      return (
        <SelectedItems
          isAddIcon={true}
          selectedItems={params.start ? [params.start] : []}
          getItemLabel={getItemLabel}
          readonly={readonly}
          handleChange={handleChange}
          filtersTitle={adDurationOptions[params.type].name}
          enableRemoveOneItem
          dataTest="max-ad-duration-exact"
        />
      );
    default:
      return null;
  }
};
